import {
  //   ApiGetRequest,
  ApiPostRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Laporan Journal',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Laporan Journal',
        href: '/adm/fin/laporan/journal',
        active: true,
      },
    ],
    form: {
      periode: '',
      tipe_akun: '1',
    },
    report: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeJournal(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getJournal({ commit, state }) {
    commit('changeJournal', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`fin/laporan/journal`, data.form);
    commit('changeJournal', {
      report: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },
};
